export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8826.03749237.jpg";